import React from "react";
import {ThirdTabProps} from "@/app/pages/upik/resources/interfacesData";
import {HeadingContent} from "@/app/pages/upik/components/HeadingContent";

interface HeadingContentInterface {
    content: string;
    heading: string;
}


const HowDoesDandBSupportUpikTab = ({
    answerOneTabThreeLocalized,
    answerTwoTabThreeLocalized,
    questionOneTabThreeLocalized,
    questionTwoTabThreeLocalized,
    language
}: ThirdTabProps): JSX.Element => {
    const dAndBSupportDataOne: HeadingContentInterface = {
        "content": language === 'de' ? "Dun & Bradstreet Deutschland entwickelt in Abstimmung mit den UPIK®-Partnern die UPIK® Online-Plattform zur kostenlosen Anlage und Pflege der eigenen Kommunikationsdaten. Dun & Bradstreet's einzigartige, weltweite Ressourcen und seine Informationsreichweite unterstützen das UPIK® Identifizierungssystem dabei, jederzeit auf eine standardisierte und vertrauensvolle Datenbasis für geschäftliche Entscheidungen zugreifen zu können." : "Dun & Bradstreet Germany is developing the UPIK<sup>®</sup> online platform in consultation with UPIK<sup>®</sup> partners for free creation and maintenance of their own communication data. D&amp;B's unique global resources and information reach support the UPIK<sup>®</sup> identification system in providing access to a standardized and trusted database for business decisions at all times.",
        "heading": language === 'de' ? "In welcher Weise unterstützt D&B UPIK®?" :  "How does D&B support UPIK<sup>®</sup>?"
    };
    
    const dAndBSupportDataTwo: HeadingContentInterface = {
        "content": language === 'de' ? "Dun & Bradstreet unterstützt die Darstellung der Unternehmen auf der Ebene von Geschäftsbereichen, zwischen denen die tatsächlichen Transaktionen (Bestellungen, Lieferabrufe, Austausch von Dokumentationen usw.) stattfinden. Dies ist zunächst nur für eine begrenzte Anzahl von Ländern möglich. UPIK® und Dun & Bradstreet erweitern ständig die Anzahl der Länder, für welche auch zu verschiedenen Geschäftsbereichen, an ein und demselben Standort eine D&B D-U-N-S® Nummer vergeben werden kann." : "D&B supports the presentation of companies at the level of business units between which the actual transations (orders, delivery schedules, exchange of documentation, etc.) take place. This is initially only possible for a limited number of countries. UPIK<sup>®</sup> & D&B are constantly expanding the number of countries for which a D&B D-U-N-S<sup>®</sup> Number can be assigned to different business divisions at one and the same location.",
        "heading": language === 'de' ? "Welchen zusätzlichen Service bietet Dun & Bradstreet, um die Geschäftsprozesse der Automobil- und Zulieferindustrie zu unterstützen?" : "What additional services does D&B offer to support the business processes of the automative and supplier industry?"
    };
    return (
    <div>
        <HeadingContent
            content={answerOneTabThreeLocalized ?? dAndBSupportDataOne.content}
            heading={questionOneTabThreeLocalized ?? dAndBSupportDataOne.heading}
        />

        <HeadingContent
            content={answerTwoTabThreeLocalized ?? dAndBSupportDataTwo.content}
            heading={questionTwoTabThreeLocalized ?? dAndBSupportDataTwo.heading}
        />
    </div>
)}

export {HowDoesDandBSupportUpikTab};
